<!-- <div *ngIf="hunt; else loading" class="hunt-container">
  <div class="header-wrapper">
    <div class="header-row">
      <div>
        <div>
          <span *ngIf="hunt.huntTemplate">
            <a
              class="link"
              routerLink="/hunt/hunt-template/{{ hunt.huntTemplate.id }}"
              >{{ hunt.huntTemplate.name }}</a
            >
          </span>
        </div>
        <div class="flex">
          <div class="inline">
            <h4 class="hunt-title">{{ hunt.name }}</h4>
          </div>
          <div class="badges">
            <span
              class="badge lg"
              [class.badge-success]="hunt.priority === priority.LOW"
              [class.badge-warning]="hunt.priority === priority.MEDIUM"
              [class.badge-danger]="hunt.priority === priority.HIGH"
              >{{ hunt.priority }}</span
            >
            <span
              class="badge lg"
              [class.badge-info]="hunt.status === status.TO_DO"
              [class.badge-warning]="hunt.status === status.IN_PROGRESS"
              [class.badge-success]="hunt.status === status.DONE"
              >{{ hunt.status }}</span
            >
            <span
              *ngIf="hunt.outcome"
              class="badge lg"
              [class.badge-info]="hunt.outcome === outcome.VISIBILITY_GAP"
              [class.badge-success]="hunt.outcome === outcome.NO_FINDINGS"
              [class.badge-warning]="hunt.outcome === outcome.DETECTION"
              [class.badge-danger]="hunt.outcome === outcome.ESCALATED"
              >{{ hunt.outcome }}</span
            >
            <button
              class="edit"
              size="small"
              icon="cog"
              fillMode="outline"
              themeColor="primary"
              kendoButton
              (click)="editHunt()"
            ></button>
          </div>
        </div>
      </div>
      <div class="buttons inline">
        <button
          themeColor="primary"
          kendoButton
          icon="arrow-left"
          (click)="reopenHunt()"
        >
          Reopen Hunt
        </button>
        <button
          icon="edit"
          themeColor="primary"
          kendoButton
          (click)="editReport()"
        ></button>
        <button
          fillMode="outline"
          themeColor="primary"
          (click)="archiveHunt()"
          kendoButton
        >
          Archive
        </button>
        <kendo-dropdownbutton
          themeColor="primary"
          kendoButton
          icon="export"
          [data]="exportData"
        >
          Export
        </kendo-dropdownbutton>
      </div>
    </div>
    <div>
      <span class="info">
        <span class="label">Created </span>
        <span>{{ hunt.created | date : 'longDate' }}</span>
        <span class="label">Last Modified</span>
        <span>{{ hunt.lastModified | date : 'longDate' }}</span>
        <span class="label">Author </span>
        <span *ngIf="hunt.author; else deletedAuthor"
          >{{ hunt?.author?.firstName }} {{ hunt?.author?.lastName }}</span
        >
        <ng-template #deletedAuthor> (deleted) </ng-template>
        <span class="label">Assignee </span>
        <span *ngIf="hunt.assignee"
          >{{ hunt.assignee.firstName }} {{ hunt.assignee.lastName }}</span
        >
        <span *ngIf="!hunt.assignee">Unassigned</span>
      </span>
    </div>
  </div>
</div>
<main>
  <ng-template #notShow>
    <p>--</p>
  </ng-template>
  <div class="report-container">
    <div class="row">
      <aside class="col-lg-4 px-0">
        <ul>
          <li *ngIf="validateReportString(hunt.executiveSummary)">
            <a (click)="scrollTo('executive-summary')">Executive Summary</a>
          </li>
          <li *ngIf="validateReportString(hunt.abstract)">
            <a (click)="scrollTo('abstract')">Abstract</a>
          </li>
          <li *ngIf="validateReportString(hunt.hypothesis)">
            <a (click)="scrollTo('hypothesis')">Hypothesis</a>
          </li>
          <li>
            <a (click)="scrollTo('technical-summary')">Technical Summary</a>
            <ul class="sub">
              <li>
                <a (click)="scrollTo('overview')">Overview</a>
              </li>
              <li *ngFor="let huntPack of hunt.huntPackages">
                <a
                  *ngIf="huntPack.reportAnalysis.length > 0"
                  (click)="scrollTo(huntPack.UUID)"
                >
                  {{ huntPack.title }}</a
                >
              </li>
            </ul>
          </li>
          <li *ngIf="validateReportString(hunt.conclusion)">
            <a (click)="scrollTo('conclusion')">Conclusion</a>
          </li>
          <li>
            <a (click)="scrollTo('coverage')">Coverage</a>
          </li>
        </ul>
      </aside>
      <div class="col-12 col-lg-8 px-0">
        <div #reportHtml id="reportHtml" class="report">
          <kendo-pdf-export
            #pdf
            paperSize="A4"
            [margin]="margins"
            [scale]="0.6"
            forcePageBreak=".page-break"
          >
            <ng-template
              kendoPDFTemplate
              let-pageNum="pageNum"
              let-totalPages="totalPages"
            >
              <div class="pdfHeader">
                Page {{ pageNum }} of {{ totalPages }}
              </div>
              <div class="pdfBranding">
                <img height="40" src="/assets/brand/intel-logo-light.svg" />
              </div>

              <div class="pdfFooter">
                <img src="/assets/brand/intel-bug-light.svg" />
                <span
                  ><strong
                    ><a
                      href="https://intel471.com/titan/threat-hunt-intelligence"
                      target="_blank"
                      >Intel 471 Threat Hunting Module</a
                    ></strong
                  ></span
                >
              </div>
            </ng-template>

            <div class="report-header">
              <h1>Threat Hunt Report: {{ hunt.name }}</h1>
              <p>
                <em>
                  <span *ngIf="hunt.assignee"
                    >{{ hunt.assignee.firstName }}
                    {{ hunt.assignee.lastName }}</span
                  >
                  &nbsp;
                  <span *ngIf="!hunt.assignee">Unassigned</span>
                  <span class="report-date">{{
                    hunt.lastModified | date : 'longDate'
                  }}</span></em
                >
              </p>
            </div>
            <section
              *ngIf="validateReportString(hunt.executiveSummary)"
              id="executive-summary"
            >
              <h2>Executive Summary</h2>
              <cyborg-markdown [md]="hunt.executiveSummary"></cyborg-markdown>
            </section>
            <section *ngIf="validateReportString(hunt.abstract)" id="abstract">
              <h2>Abstract</h2>
              <cyborg-markdown [md]="hunt.abstract"></cyborg-markdown>
            </section>
            <section
              *ngIf="validateReportString(hunt.hypothesis)"
              id="hypothesis"
            >
              <h2>Hypothesis</h2>
              <cyborg-markdown [md]="hunt.hypothesis"></cyborg-markdown>
            </section>
            <section id="technical-summary">
              <h2>Technical Summary</h2>
              <h3 id="overview">Overview</h3>

              <h4>Outcome</h4>
              <p
                class="badge lg"
                [class.badge-info]="hunt.outcome === outcome.VISIBILITY_GAP"
                [class.badge-success]="hunt.outcome === outcome.NO_FINDINGS"
                [class.badge-warning]="hunt.outcome === outcome.DETECTION"
                [class.badge-danger]="hunt.outcome === outcome.ESCALATED"
              >
                {{ hunt.outcome }}
              </p>
              <section *ngIf="validateReportString(hunt.outcomeDependent)">
                <h3>{{ outcomeDependentText }}</h3>
                <cyborg-markdown [md]="hunt.outcomeDependent"></cyborg-markdown>
              </section>
              <section id="hunt-packages">
                <section
                  *ngFor="let huntPack of hunt.huntPackages"
                  [attr.id]="huntPack.UUID"
                >
                  <div *ngIf="huntPack.reportAnalysis.length > 0">
                    <a
                      class="huntPack link"
                      href="https://hunter.cyborgsecurity.io/research/hunt-package/{{
                        huntPack.UUID
                      }}"
                      target="_blank"
                    >
                      <h3>{{ huntPack.title }}</h3></a
                    >
                    <section
                      *ngIf="validateReportString(huntPack.description)"
                      id="threat-description"
                    >
                      <h4>Threat Description</h4>
                      <cyborg-markdown
                        [md]="huntPack.description"
                      ></cyborg-markdown>
                    </section>
                    <section
                      *ngIf="
                        validateReportString(
                          huntPack?.response_actions?.mitigation_recommendations
                        )
                      "
                      id="mitigationRecommendations"
                    >
                      <h4>Mitigation Recommendations</h4>
                      <cyborg-markdown
                        [md]="
                          huntPack?.response_actions?.mitigation_recommendations
                        "
                      ></cyborg-markdown>
                    </section>
                    <section
                      id="mitreInformation"
                      *ngIf="
                        huntPack?.mapping?.mitre?.mitre_attack_tactics.length >
                        0
                      "
                    >
                      <div
                        *ngIf="
                          huntPack?.mapping?.mitre?.mitre_attack_tactics
                            .length > 0
                        "
                        id="mitre"
                      >
                        <h4>MITRE Information</h4>
                        <h5><em>Mitre Attack Tactic</em></h5>
                        <p>
                          {{
                            huntPack?.mapping?.mitre?.mitre_attack_tactics.join(
                              ', '
                            )
                          }}
                        </p>
                        <h5><em>Mitre Attack Techniques</em></h5>
                        <p>
                          {{
                            huntPack?.mapping?.mitre?.mitre_attack_techniques.join(
                              ', '
                            )
                          }}
                        </p>
                        <h5><em>Mitre Attack Id</em></h5>
                        <p
                          class="mitre-id"
                          *ngFor="
                            let id of huntPack?.mapping?.mitre
                              ?.mitre_attack_technique_ids;
                            last as isLast
                          "
                        >
                          <a
                            class="link"
                            href="https://attack.mitre.org/techniques/{{
                              id.replace('.', '/')
                            }}"
                            target="_blank"
                            >{{ id }}</a
                          >
                          <span *ngIf="!isLast">, &nbsp;</span>
                        </p>
                      </div>
                    </section>
                    <section
                      *ngIf="huntPack.reportAnalysis.length > 0"
                      id="analysis"
                    >
                      <h4>Analysis</h4>
                      <div *ngFor="let environment of huntPack.reportAnalysis">
                        <section>
                          <div *ngFor="let tool of environment.tools">
                            <div
                              *ngFor="let content of tool.generatedContent.Hunt"
                            >
                              <h5>
                                <em>
                                  {{ environment.name }}: {{ tool.name }} -
                                  {{ content.category }}
                                </em>
                              </h5>
                              <section>
                                <h6 class="label">Query</h6>
                                <pre>{{ content.query }}</pre>
                              </section>
                              <section>
                                <h6 class="label">Notes</h6>
                                <cyborg-markdown
                                  [md]="content.notes"
                                ></cyborg-markdown>
                              </section>
                            </div>
                          </div>
                        </section>
                      </div>
                    </section>
                  </div>
                </section>
              </section>
            </section>
            <section *ngIf="hunt.conclusion" id="conclusion">
              <h2>Conclusion</h2>
              <cyborg-markdown [md]="hunt.conclusion"></cyborg-markdown>
            </section>
            <section id="coverage">
              <h2 class="new-page">Coverage</h2>
              <div class="coverage outer-section">
                <div class="outer-wrapper">
                  <div class="inner-block">
                    <h3>Top MITRE</h3>

                    <div
                      id="top-mitre-container"
                      style="width: 450px; height: 450px"
                    ></div>
                    <table class="coverage-table">
                      <thead>
                        <tr>
                          <th>Technique</th>
                          <th>Tactic</th>
                          <th>Packages</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let mitre of huntMITRECoverage">
                          <td>
                            <a
                              class="link"
                              href="https://attack.mitre.org/techniques/{{
                                mitre.name.replace('.', '/')
                              }}"
                              target="_blank"
                              >{{ mitre.name }}</a
                            >
                          </td>
                          <td>{{ mitre?.category }}</td>
                          <td class="link">{{ mitre.huntPackageCount }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="new-page coverage outer-section">
                <div class="outer-wrapper">
                  <div class="inner-block">
                    <h3>Top Actors</h3>
                    <div
                      id="top-actors-container"
                      style="width: 450px; height: 450px"
                    >
                      <img src="${imageUrl}" alt="Chart" />
                    </div>
                    <table class="coverage-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Origin</th>
                          <th>Packages</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let actor of huntActorCoverage">
                          <td>{{ actor?.name }}</td>
                          <td>{{ actor?.category }}</td>
                          <td class="link">{{ actor?.huntPackageCount }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="new-page coverage outer-section">
                <div class="outer-wrapper">
                  <div class="inner-block">
                    <h3>Top Threats</h3>
                    <div
                      id="top-threats-container"
                      style="width: 450px; height: 450px"
                    >
                      <img src="${imageUrl}" alt="Chart" />
                    </div>
                    <table class="coverage-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Packages</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let threat of huntThreatCoverage">
                          <td>{{ threat.name }}</td>
                          <td class="link">{{ threat.huntPackageCount }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </section>
          </kendo-pdf-export>
        </div>
      </div>
    </div>
  </div>
</main>
<ng-template #loading>
  <div class="loading">
    <kendo-loader type="pulsing" themeColor="primary" size="large">
    </kendo-loader>
  </div>
</ng-template> -->
<div id="hunt-details-page-wrapper">
  <div class="page-header">
    <div class="left">
      <hyperkit-breadcrumb-list class="breadcrumb-list" [items]="breadcrumbs()"></hyperkit-breadcrumb-list> 
      <hyperkit-typography variant="h2">{{ huntContext.state.name() }}</hyperkit-typography>
      <div class="meta-data-tags">
        <hyperkit-badge
        [variant]="huntContext.editor.priorityVariant()"
        [size]="'base'"
        [indicator]="'none'"
        [text]="huntContext.editor.priority()">
      </hyperkit-badge>
      <hyperkit-badge
      [variant]="huntContext.editor.statusVariant()"
      [size]="'base'"
      [indicator]="'none'"
      textLeft="Status"
      [text]="huntContext.editor.status()">
    </hyperkit-badge>
    <hyperkit-badge
    *ngIf="huntContext.editor.outcome()"
    [variant]="huntContext.editor.outcomeVariant()"
    [size]="'base'"
    [indicator]="'none'"
    textLeft="Outcome"
    [text]="huntContext.editor.outcome()">
  </hyperkit-badge>
      <hyperkit-tag
        [mode]="'outline'"
        [closable]="false"
        [textLeft]="'Created'"
        [text]="huntContext.state.created()">
      </hyperkit-tag>

      <hyperkit-tag
      [mode]="'outline'"
      [closable]="false"
      [textLeft]="'Last Modified'"
      [text]="huntContext.state.lastModified()">
    </hyperkit-tag>
      
      <hyperkit-tag
        [mode]="'outline'"
        [closable]="false"
        [textLeft]="'Author'"
        [text]=" huntContext.state.assigneeFullName()">
      </hyperkit-tag>
      <hyperkit-tag
      [mode]="'outline'"
      [closable]="false"
      [textLeft]="'Author'"
      [text]=" huntContext.state.authorFullName()">
    </hyperkit-tag>
      <hyperkit-tag
      *ngIf="huntContext.query.hasHuntTemplate()"
      routerLink="/hunt/hunt-template/{{ huntContext.state.huntTemplateId()}}"
      icon="link-2"
      [mode]="'fill'"
      [closable]="false"
      [textLeft]="'Template'"
      [text]=" huntContext.state.huntTemplateName()">
    </hyperkit-tag>        
    </div>
    </div>
    <div class="right">
      <hyperkit-error *ngIf="error" [error]="error"></hyperkit-error>
      <hyperkit-button variant="standard" color="secondary" size="small" text="Reopen" (click)="reopenHunt()" icon="arrow-left" iconPosition="left"></hyperkit-button>
      <hyperkit-button-menu variant="standard" iconPosition="right" color="secondary"  size="small" icon="download" (itemSelected)="handleMenuAction($event)" text="Export" >
        <hyperkit-dropdown-menu-item value="archive" label="PDF"></hyperkit-dropdown-menu-item>
        <hyperkit-dropdown-menu-item value="update" label="Word"></hyperkit-dropdown-menu-item>
      </hyperkit-button-menu>
    </div>
  </div>
  <div class="page-content">
    <div id="report">
      <div id="report-header">
        <div id="report-title">
          <hyperkit-typography variant="h5">Threat Hunt Report</hyperkit-typography>
        </div>
        <div id="report-list">
          <div class="report-container">
            <div *ngFor="let section of sections()">
              <hyperkit-report-section 
                [section]="section" 
                [selectedSectionId]="selectedSectionId"
                (selectSection)="onSelectSection($event)">
              </hyperkit-report-section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="report-details">
      <router-outlet></router-outlet>
    </div>
    <div id="hunt-notes">
      <report-text-block 
      title="Notes"
      [value]="huntContext.state.notes()"
      >
    </report-text-block>
    </div>
</div>
</div>
